"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverse = void 0;
exports.reverse = (value) => value.split("").reverse().join("");
//# sourceMappingURL=reverse.js.map